<template>
    <div class="balance-container">
        <div class="balance-container__frame">
            <loader-oval-blue class="circle"></loader-oval-blue>
        </div>
    </div>
</template>

<script>
import LoaderOvalBlue from 'Images/loaders/oval-blue.svg?inline';

export default {
    name: 'LoadingDetail',
    components: { LoaderOvalBlue },
};
</script>

<style scoped lang="scss">
.balance-container {
}
.circle {
    margin: 10% auto auto 45%;
    height: 300px;
    width: 300px;
    @media (max-width: $xm-up) {
        margin: 15% auto auto 45%;
    }
    @media (max-width: $sm-up) {
        margin: 20% auto auto 40%;
    }
    @media (max-width: $xs-up) {
        margin: 50% auto auto 35%;
        width: 60%;
    }
}
</style>
